<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field
          v-if="!detail"
          :label="$t('addEditMoisComptable.information.dateDebut')"
          class="obligatoire">
          <div class="columns is-vcentered" >
            <b-datepicker
              v-model="data.dateDebut"
              class="column"
              icon="calendar-today"
              position="is-bottom-right"
              editable
              nearby-selectable-month-days
              show-week-number>
            </b-datepicker>
          </div>
        </b-field>
        <div v-else>
          <p class="has-text-default is-italic">
            {{ $t('detailMoisComptable.information.dateDebut') }}
          </p>
          <p class="has-text-weight-bold">
            {{ data.dateDebut | formatDate }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <b-field
          v-if="!detail"
          :label="$t('addEditMoisComptable.information.dateFin')"
          class="obligatoire">
          <div class="columns is-vcentered" >
            <b-datepicker
              v-model="data.dateFin"
              class="column"
              icon="calendar-today"
              position="is-bottom-right"
              editable
              nearby-selectable-month-days
              show-week-number>
            </b-datepicker>
          </div>
        </b-field>
        <div v-else>
          <p class="has-text-default is-italic">
            {{ $t('detailMoisComptable.information.dateFin') }}
          </p>
          <p class="has-text-weight-bold">
            {{ data.dateFin | formatDate }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <b-field
          v-if="!detail"
          :label="$t('addEditMoisComptable.information.etat')"
          class="obligatoire">
          <b-select v-model="data.etat" expanded>
            <option
              v-for="items in constantes.MOIS_COMPTABLE_TYPE"
              :key="items.value"
              :value="items.value">
              {{ $t(items.libelle) }}
            </option>
          </b-select>
        </b-field>
        <div v-else>
          <p class="has-text-default is-italic">
            {{ $t('detailMoisComptable.information.etat') }}
          </p>
          <p class="has-text-weight-bold">
            {{ getLibelleEtat(data.etat) }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <b-field
          v-if="!detail"
          :label="$t('addEditMoisComptable.information.exerciceComptable')"
          class="obligatoire">
          <b-select v-model="data.exerciceComptableId" expanded>
            <option :value="null"></option>
            <option
              v-for="item in excercices" :key="item.id"
              :value="item.id">
              {{item.code}}
            </option>
          </b-select>
        </b-field>
        <div v-else>
          <p class="has-text-default is-italic">
            {{ $t('detailMoisComptable.information.exerciceComptable') }}
          </p>
          <p class="has-text-weight-bold">
            {{ data.exerciceComptable.code }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { MOIS_COMPTABLE_TYPE } from '@/configuration/presse/presseConfig';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  data() {
    return {
      constantes: {
        MOIS_COMPTABLE_TYPE,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    excercices() {
      return this.parametre(PARAMETRES_KEYS.exercice);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLibelleEtat(value) {
      const find = MOIS_COMPTABLE_TYPE.find((s) => s.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.exercice]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
